export const getMessages = store => store.messages
